import React from 'react';
import { Button } from '@sm/wds-react';
import { IconCaretDown } from '@sm/wds-icons';

export const MyTeamTrigger = title => {
  return (
    <Button
      size="sm"
      variant="text"
      className="sm-header__nav-cta--alt sm-header__text"
      key={title}
    >
      {title}
      <IconCaretDown />
    </Button>
  );
};

export default MyTeamTrigger;
